<template>
  <div class="flex flex-row justify-between wizard">
    <div
      class="flex flex-col w-1/3 wizard-step"
      v-for="(step, index) in steps"
      :key="index"
    >
      <div class="w-full">
        <div class="wizard-step-number flex w-full">
          <div
            class="flex items-center justify-center w-8 h-8 mb-4 rounded-full bg-green text-white z-50"
            :class="{
              'bg-green': index + 1 < activeStep,
              'bg-dark': index + 1 == activeStep,
              'bg-grey-500': index + 1 > activeStep,
            }"
          >
            {{ index + 1 }}
          </div>
        </div>
      </div>
      <div class="flex flex-row justify-center">
        <p class="mb-2 text-grey-700 text-sm">{{ step }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['steps', 'activeStep'],
};
</script>


<style scoped>
.wizard .wizard-step .wizard-step-number:after {
  content: '';
  flex: 1;
  margin: 1em 0px;
  height: 0;
  border-top: solid #cccedc 1px;
}

.wizard .wizard-step:last-child .wizard-step-number:after {
  visibility: hidden;
}

.wizard .wizard-step .wizard-step-number:before {
  content: '';
  flex: 1;
  margin: 1em 0px;
  height: 0;
  border-top: solid #cccedc 1px;
}

.wizard .wizard-step:first-child .wizard-step-number:before {
  visibility: hidden;
}
</style>